import { Link, Outlet } from '@tanstack/react-router';
import type { TenantMe } from '@studio/contracts';
import { PRODUCT_NAME } from '@studio/contracts';
import { navForRole } from '@/nav';
import { BrandSwitcher } from './brand-switcher';
import { Icon } from './icons';
import { ProfileMenu } from './profile-menu';

const ROLE_TITLE: Record<string, string> = { creator: 'Creator', reviewer: 'Reviewer', editor: 'Editor', owner: 'Owner' };

export function Shell({ me }: { me: TenantMe }) {
  const role = me.active?.role ?? 'reviewer';
  const sections = navForRole(role);
  return (
    <div className="app">
      <aside className="side" aria-label={`${PRODUCT_NAME} navigation`}>
        <BrandSwitcher me={me} />
        <nav className="nav">
          {sections.map((s) => (
            <div key={s.title}>
              <div className="sec">{s.title}</div>
              {s.items.map((i) => (
                <Link key={i.key} to={i.to} activeOptions={{ exact: i.to === '/' }}>
                  <Icon name={i.icon} />
                  <span>{i.label}</span>
                </Link>
              ))}
            </div>
          ))}
        </nav>
        <div className="foot">
          <ProfileMenu me={me} />
          <div className="who">
            <div className="n">{me.displayName || me.email}</div>
            <div className="r">{ROLE_TITLE[role]} · {me.active?.orgName ?? 'no organisation'}</div>
          </div>
        </div>
      </aside>
      <div className="main">
        <Outlet />
      </div>
    </div>
  );
}

export function TopBar({ title, children, right }: { title: string; children?: React.ReactNode; right?: React.ReactNode }) {
  return (
    <header className="top">
      <h1>{title}</h1>
      {children}
      {right && <div className="right">{right}</div>}
    </header>
  );
}
